import BaseApiService from './BaseApiService'

class TemplateService extends BaseApiService {
   constructor() {
      super()
   }

   async getTemplateTypes() {
      return await super.execute('get', `template/types`)
   }

   async getTemplateFields(templateTypeId) {
      return await super.execute('get', `template/fields/${templateTypeId}`)
   }
   
   async listUserTemplatesByType(templateTypeId, userId) {
      return await super.execute('get', `template/${templateTypeId}/${userId}`)
   }

   async listUserTemplates(templateTypeCode, userId) {
      return await super.execute('get', `template/${templateTypeCode}/${userId}`)
   }

   async getUserTemplate(templateId) {
      return await super.execute('get', `template/${templateId}`)
   }

   async deleteUserTemplate(templateId) {
      return await super.execute('get', `template/del/${templateId}`)
   }

   async getBlankTemplate() {
      return await super.execute('get', `template/blank`)
   }

   async saveUserTemplate(payload) {
      return await super.execute('post', `template`, payload)
   }
      
   async getTemplateImages(templateId) {
      return await super.execute('get', `document/images/${templateId}`)
   }

   async deleteTemplateImage(imageId) {
      return await super.execute('get', `document/imgdel/${imageId}`)
   }
}

export let templateApi = new TemplateService()